import { render, staticRenderFns } from "./InformedConsent.vue?vue&type=template&id=7db909af&scoped=true&"
import script from "./InformedConsent.vue?vue&type=script&lang=js&"
export * from "./InformedConsent.vue?vue&type=script&lang=js&"
import style0 from "./InformedConsent.vue?vue&type=style&index=0&id=7db909af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db909af",
  null
  
)

export default component.exports